import { Definitions } from './Definitions';

export const DefinitionsContainer = () => {
  return <Definitions />;
};
